/**
 * User API functions
 */
import { ENDPOINTS } from './endpoints';
import { getRequestBackendDataV2, postRequestBackendDataV2, deleteRequestBackendDataV2 } from './core';

export async function postCopilotLoginV2(auth, callback, data) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.USER.LOGIN, data);
}

export async function getMessageLimitV2(auth, callback) {
    await getRequestBackendDataV2(auth, (data) => {
        if (data.error) {
            callback({ error: data.error });
        } else {
            callback({
                ...data
            });
        }
    }, ENDPOINTS.USER.MESSAGE_LIMIT);
}

// User API Key functions
export async function getUserApiKeys(auth, callback) {
    await getRequestBackendDataV2(auth, callback, ENDPOINTS.USER.API_KEYS);
}

export async function saveUserApiKey(auth, callback, provider, apiKey) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.USER.API_KEY(provider), { apiKey }, 'PUT');
}

export async function deleteUserApiKey(auth, callback, provider) {
    await deleteRequestBackendDataV2(auth, callback, ENDPOINTS.USER.API_KEY(provider));
}

export async function getUserApiKeyStatus(auth, callback) {
    await getRequestBackendDataV2(auth, callback, ENDPOINTS.USER.API_KEYS_STATUS);
}
